module.exports = __webpack_public_path__ + "img/mission1.59df24a3.png";